import React from 'react';
import { Card, Image, Badge, Row, Col } from 'react-bootstrap';
import { formatDate, formatDuration, calculatePace } from '../../utils/formatters';

const ActivityCard = ({ activity_info, onUsernameClick, handleImageClick, attachments }) => (
    <Card className="mb-3">
        {activity_info.userName &&
            <Card.Header className="d-flex align-items-center" onClick={() => onUsernameClick(activity_info.username)} style={{ cursor: 'pointer' }}>
                {activity_info.profilePicture && (
                    <Image
                        src={activity_info.profilePicture}
                        roundedCircle
                        style={{ width: 40, height: 40, marginRight: 10 }}
                        alt="profile"
                    />
                )}
                {activity_info.userName && <div>{activity_info.userName}</div>}
            </Card.Header>}
        <Card.Body>
            {activity_info.activities.map((activity, index) => (
                <div key={index} className="mb-3">
                    <div className="d-flex align-items-center mb-2">
                        <strong>{activity.firstName}</strong>
                        {activity.isPersonalBest && <Badge bg="success" className="ms-2">Personal Best!</Badge>}
                        {activity.isPersonalWorst && <Badge bg="danger" className="ms-2">Personal Worst!</Badge>}
                    </div>
                    <Row>
                        <Col md={6}>
                            <div><strong>Activity type:</strong> {activity.activityType}</div>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col md={6}>
                            <div><strong>Points:</strong> {parseFloat(activity.points).toFixed(2)}</div>
                            <div><strong>Distance:</strong> {parseFloat(activity.distance).toFixed(2)} km</div>
                            {activity.calories > 0 && (
                                <div><strong>Calories:</strong> {activity.calories.toFixed(0)} calories</div>
                            )}
                        </Col>
                        <Col md={6}>
                            <div><strong>Duration:</strong> {formatDuration(activity.duration)}</div>
                            <div><strong>Elevation:</strong> {(parseFloat(activity.elevation) || 0).toFixed(0)} m</div>
                            <div><strong>Average Pace:</strong> {calculatePace(activity.duration, activity.distance, activity.type)}</div>
                            {activity.calories > 0 &&  (
                                <div>
                                    <strong>Calories per point:</strong> {(activity.calories / parseFloat(activity.points)).toFixed(2)} calories/point
                                </div>
                            )}
                            {activity.description && <p>{activity.description}</p>}
                        </Col>
                    </Row>
                    {activity.photos?.length > 0 && (
                        <Row className="mt-2">
                            {activity.photos.map((photo, photoIndex) => (
                                <Col xs={6} md={4} lg={3} key={photoIndex}>
                                    <Image
                                        src={photo}
                                        alt="Attachment image"
                                        className="clickable-image"
                                        onClick={() => handleImageClick(photo)}
                                        fluid
                                    />
                                </Col>
                            ))}
                        </Row>
                    )}
                    {activity.attachments?.length > 0 && (
                        <Row className="mt-2">
                            {activity.attachments.map((attachment, attachmentIndex) => (
                                <Col xs={6} md={4} lg={3} key={attachmentIndex}>
                                    <Image
                                        src={attachments[attachment.url] || attachment.url}
                                        alt={attachment.name}
                                        className="clickable-image"
                                        onClick={() => handleImageClick(attachments[attachment.url] || attachment.url)}
                                        fluid
                                    />
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            ))}
        </Card.Body>
    </Card>
);

export default ActivityCard;
